import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = {
  key: 0,
  class: "witnesses"
}
const _hoisted_3 = {
  key: 1,
  class: "agrees",
  title: "Marked “= 𝔐”: the reading agrees with the Hebrew"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.origin !== 'head')
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["origin-badge", _ctx.origin]),
        title: _ctx.title
      }, [
        _createTextVNode(_toDisplayString(_ctx.named.badge), 1),
        (_ctx.witnesses.length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.witnesses.join(' ')), 1))
          : _createCommentVNode("", true),
        (_ctx.agreesWithMt)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, " = 𝔐"))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}